import { ActionType, ActionTypeHelper, IAssetModel } from "@xala/common-services";
import { Choose, ChooseOption, Form } from "@xala/common-ui";
import React from "react";
import { useTranslation } from "react-i18next";

interface IActionTypesProps {
  readonly setValue: (value: ActionType | undefined) => void;
  readonly value: ActionType | undefined;
}

function ActionTypes({ setValue, value }: Readonly<IActionTypesProps>) {
  const { t } = useTranslation();

  return (
    <Form.Item<IAssetModel>
        name="ActionType"
        label={t("Action type")}
        required
      >
        <Choose
          allowClear={true}
          placeholder={t("Select action type")}
          value={value}
          onChange={(value?: string) => {
            if (value == null) {
              setValue(undefined);
            } else {
              setValue(value as ActionType);
            }
          }}
        >
          <ChooseOption key={ActionType.OpenMedia} value={ActionType.OpenMedia}>
            {ActionTypeHelper.getDescription(ActionType.OpenMedia)}
          </ChooseOption>
          <ChooseOption key={ActionType.OpenMediaCollection} value={ActionType.OpenMediaCollection}>
            {ActionTypeHelper.getDescription(ActionType.OpenMediaCollection)}
          </ChooseOption>
          <ChooseOption key={ActionType.OpenScreen} value={ActionType.OpenScreen}>
            {ActionTypeHelper.getDescription(ActionType.OpenScreen)}
          </ChooseOption>
          <ChooseOption key={ActionType.OpenUrl} value={ActionType.OpenUrl}>
            {ActionTypeHelper.getDescription(ActionType.OpenUrl)}
          </ChooseOption>
          <ChooseOption key={ActionType.NoAction} value={ActionType.NoAction}>
            {ActionTypeHelper.getDescription(ActionType.NoAction)}
          </ChooseOption>
        </Choose>
      </Form.Item>
  );
}

export default ActionTypes;